import React from 'react'
import {useNavigate } from 'react-router-dom'
import LogoPaimentFacture from '../../assets/iconTsx/logoPaimentFacture'
import LogoTransferBancaire from '../../assets/iconTsx/logoTransferBancaire'
import LogoTransfer from '../../assets/iconTsx/logoTransfer'
import LogoRecharge from '../../assets/iconTsx/logoRecharge'
import LogoAssurance from '../../assets/iconTsx/logoAssurance'
import LogoCartePrepayee from '../../assets/iconTsx/logoRechargePrepayee'
import LogoWallet from 'assets/iconTsx/logoWallet'
import logoESim from '../../assets/iconTsx/logoESim'
import IConBientot from '../../assets/bientot.png'
import IconExclusive from '../../assets/exclusive.png'
import IconzeroFrais from '../../assets/zeroFrais.png'
import IconTopVente from '../../assets/topVente.png'
import IconTopVenteTransfert from '../../assets/topVenteTransfert.png'


const homeBlockLinks: React.FC = () => {
  const list: {
     image: string |React.ElementType ,
      linkTo: string; text: string , 
      backgroundColor: string, 
      colorFlech:string,
      bientot?:boolean
      hover?: string,
      Badges?: string,
      colorBadges?:string,
      iconBadges?: string 
    }[] = [
    { image: LogoTransfer, linkTo: '/transfert/0', text: "Transfert d'argent avec retrait en cash ", backgroundColor:'#E6E6FB', colorFlech:'text-[#5754E5] group-hover:text-[#4D36CC]', hover:'group-hover:fill-[#4D36CC] xl:w-[55] xl:h-[55px] sm:w-[42] sm:h-[42px]', iconBadges:IconTopVenteTransfert},
    { image: LogoPaimentFacture, linkTo: '/paimentFacture', text: 'Paiement de factures locales ', backgroundColor: '#E1F6FF' ,  colorFlech:'text-[#38C3FF] group-hover:text-[#33B0E6]', hover:'group-hover:fill-[#33B0E6] xl:w-[55] xl:h-[55px] sm:w-[42] sm:h-[42px]', iconBadges:IconExclusive},

    { image: LogoTransferBancaire, linkTo: '/transfert/1', text: "Transfert d’argent de compte à compte " , backgroundColor:'#DEF6EA',  colorFlech:'text-[#20C374] group-hover:text-[#1DB069]' , hover:'group-hover:fill-[#1DB069] ', iconBadges:IconzeroFrais },
    { image: LogoCartePrepayee, linkTo: '/rechargeCartePrepayee', text: 'Recharge de carte prépayée européenne' , backgroundColor: '#FFE3DB',  colorFlech:'text-[#FF6C47] group-hover:text-[#FF5E36]', hover:'group-hover:fill-[#FF5E36] xl:w-[55] xl:h-[55px] sm:w-[42] sm:h-[42px]' },
    { image: LogoWallet, linkTo: '/transfert-vers-wallet', text: 'Transfert d’argent vers Wallet ', backgroundColor: '#FFE8CD' ,  colorFlech:'text-[#B28858] group-hover:text-[#9D7241]', hover:'group-hover:fill-[#9D7241] xl:w-[55] xl:h-[55px] sm:w-[42] sm:h-[42px]' },
    { image: LogoAssurance, linkTo: '/assurance', text: 'Souscription assurance locale ', backgroundColor: '#FFEBF7' ,  colorFlech:'text-[#FF76C8] group-hover:text-[#E66AB4]', hover:'group-hover:fill-[#E66AB4] xl:w-[55] xl:h-[55px] sm:w-[42] sm:h-[42px]'  },
    { image: LogoRecharge, linkTo: '/recharge', text: 'Envoi de recharge mobile ', backgroundColor:'#FFF6D9' ,  colorFlech:'text-[#FFC000] group-hover:text-[#E6AD00]' , hover:'group-hover:fill-[#E6AD00] xl:w-[55] xl:h-[55px] sm:w-[42] sm:h-[42px]', iconBadges:IconTopVente },

    // { image: LogoAssurance, linkTo: '/', text: 'Souscription assurance locale ',backgroundColor: '' ,  colorFlech:'', bientot: true, hover:'fill-[#9EA2AE] sm:w-[42] sm:h-[42px]'},
    // { image: LogoPaimentFacture, linkTo: '/', text: 'Paiement de factures locales ',backgroundColor: '' ,  colorFlech:'', bientot: true, hover:'fill-[#9EA2AE] sm:w-[42] sm:h-[42px]'},
    { image: logoESim, linkTo: '/', text: 'Achat de eSIM ',backgroundColor: '' ,  colorFlech:'', bientot: true, hover:'fill-[#DDDDDD] xl:w-[55] xl:h-[55px] sm:w-[42] sm:h-[42px]', iconBadges:IConBientot},
  ]

  
  const navigate = useNavigate()
  return (
    <div className="grid grid-cols-2 gap-[24px] lg:gap-4  items-center ">
      {list.map((item, index) => {
        const ImageComponent = item.image
    return(
      <div key={index}  onClick={()=>{navigate(item?.linkTo)}}
      className={`${item.bientot ? ' bg-[#FAFAFA] cursor-not-allowed' : 'lg:bg-[#F2F2F2] bg-[#FFF] cursor-pointer'}  shadow-[0px_5px_22px_-4px_rgba(0,0,0,0.1)] sm:shadow-none sm:rounded-[10px]  rounded-[8px]
          h-[120px] w-full p-[25px] 3xl:p-2 xl:p-[25px] group sm:p-2 flex items-center sm:items-start justify-between sm:flex-col relative`}
      >
        {/* <div className='flex justify-between sm:flex-col items-center'> */}
          <div className='flex gap-4 sm:gap-2 items-center sm:items-start sm:flex-col w-[80%] sm:w-full'>
           <div className='w-[60px] sm:w-[43px] h-auto sm:-ml-[10px] '> <ImageComponent styleCssImage={` ${item.hover}` }/></div>
            <h2 className={` ${item.bientot && 'text-[#D7D7D7]'} text-[14px] xl:text-[14px] 2xl:text-[12px] font-semibold `}>{item.text}</h2>

          </div>
          <svg className={`sm:hidden ${item.bientot && 'hidden'}  ${item.colorFlech}`} id='group' width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
           <path d="M0 15C0 7.92894 -2.38419e-07 4.3934 2.19669 2.19669C4.3934 -2.38419e-07 7.92894 0 15 0C22.071 0 25.6066 -2.38419e-07 27.8034 2.19669C30 4.3934 30 7.92894 30 15C30 22.071 30 25.6066 27.8034 27.8034C25.6066 30 22.071 30 15 30C7.92894 30 4.3934 30 2.19669 27.8034C-2.38419e-07 25.6066 0 22.071 0 15Z" fill={item.backgroundColor}/>
           <path d="M17 11C17 11 21 13.9459 21 15C21 16.0541 17 19 17 19" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
           <path d="M20.332 15L8.9987 15" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
          </svg>


        {/* </div> */}
        {item.iconBadges && <img className={`${item.iconBadges===IconExclusive? '-top-[4.5px] sm:-top-[4px] ': '-top-[12px] sm:-top-[10px] ' }absolute -top-[12px] sm:-top-[10px] right-[25px] 3xl:right-2 xl:right-[25px] sm:right-2 sm:w-[85px]`} src={item.iconBadges} width={100} height={35} alt=''/>}

      </div>
        // <div
        //   key={index}
        //    onClick={() => { 
        //     // if(!( item.linkTo==='/paimentFacture'))
        //     navigate(item?.linkTo)
        //   }
        // }

        //   className={` ${item.Badges ? '2xl:items-center' : 'items-center'} group flex  h-[110px] justify-between   px-3 xl:px-2 sm:h-[160px] sm:px-0 sm:pl-2  rounded-xl 
        //   ${item.bientot ? 'bg-[#E5E7EA] cursor-not-allowed' : 'bg-[#FFFFFF] shadow-selct cursor-pointer'}
        // `}
        // >

        //   <div className={`flex items-center gap-3 sm:flex-col sm:items-start `}>
        //     <div className='sm:flex sm:w-full sm:items-start sm:pr-2 justify-between'>
        //       {/* <img className =' sm:w-10 sm:h-10 ' width={55} height={55} src={item.image} alt={item.text}/> */}
        //       <ImageComponent styleCssImage={` ${item.hover}` } />

        //       {item.bientot  && 
        //         <div className='hidden bg-[#9EA2AE] rounded-md sm:flex items-center gap-2 text-[10px] font-semibold  sm:py-1 px-2 text-[#FFFFFF] '>
        //           Bientôt  <img src={item.iconBadges} alt="badge icon" width={10} height={10} />

        //           </div>
        //       }
        //      {item.Badges  && <div className={`${item.colorBadges} rounded-md text-[#FFFFFF] hidden sm:flex items-center gap-2 text-[10px] font-semibold  sm:p-1 `}>
        //       {item.Badges}
        //       <img src={item.iconBadges} alt="badge icon" width={10} height={10} />
        //       </div>}

        //     </div>
            
        //     <div className={`font-bold text-[14px] xl:text-[12px] lg:text-[14px]  max-w-[240px] lg:h-[55px] 3xl:w-full ${item.bientot ? 'text-[#9EA2AE]  sm:w-full': 'text-black'}`}>
        //       {item.text}
        //     </div>
           
        //   </div>
        //   {item.bientot  ? 
        //     <div className='bg-[#9EA2AE] rounded-lg xl:rounded-[8px] text-[#FFFFFF] text-[12px] sm:hidden flex items-center gap-2 font-semibold px-3 xl:text-[9px] lg:text-[12px] xl:px-1 lg:px-3 py-1'>
        //       Bientôt <img src={item.iconBadges} alt="badge icon" width={10} height={10} />
        //     </div>
        //     :
        //   <div className='sm:hidden  flex flex-col items-end gap-3 '>
        //      {item.Badges  && <div className={`${item.colorBadges} flex items-center justify-between rounded-b-lg xl:rounded-b-[6px] text-[#FFFFFF] text-[12px] xl:text-[9px] lg:text-[12px] xl:px-1 lg:px-3 font-semibold px-2 py-1 sm:hidden w-[89px] `}>
        //       {item.Badges}
        //       <img src={item.iconBadges} alt="badge icon" width={10} height={10} />
        //       </div>}
           
        //    <svg className={`sm:hidden ${item.colorFlech}`} id='group' width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
        //     <path d="M0 15C0 7.92894 -2.38419e-07 4.3934 2.19669 2.19669C4.3934 -2.38419e-07 7.92894 0 15 0C22.071 0 25.6066 -2.38419e-07 27.8034 2.19669C30 4.3934 30 7.92894 30 15C30 22.071 30 25.6066 27.8034 27.8034C25.6066 30 22.071 30 15 30C7.92894 30 4.3934 30 2.19669 27.8034C-2.38419e-07 25.6066 0 22.071 0 15Z" fill={item.backgroundColor}/>
        //     <path d="M17 11C17 11 21 13.9459 21 15C21 16.0541 17 19 17 19" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        //     <path d="M20.332 15L8.9987 15" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
        //     </svg>

        //   </div>
        //     }
          
        // </div>
      )
    })}
    </div>
  )
}

export default homeBlockLinks
